import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TermsConditions() {
  return (
    <div className="min-h-screen bg-pastel-gradient">
      <div className="container-pastel px-4 py-12">
        <Link
          to="/"
          className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-8 font-poppins"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Link>

        <div className="card-pastel p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-8 font-poppins">Terms and Conditions</h1>

          <div className="max-w-none text-gray-700">
            <p className="text-sm text-gray-500 mb-6 font-poppins">Last updated: {new Date().toLocaleDateString()}</p>

            <div className="bg-white/60 p-6 rounded-lg mb-8">
              <h2 className="text-xl font-semibold mb-4 text-gray-800 font-poppins">Table of Contents</h2>
              <ol className="list-decimal list-inside space-y-2 font-poppins text-gray-600">
                <li><a href="#acceptance" className="hover:text-pastel-purple-600">Acceptance of Terms</a></li>
                <li><a href="#user-accounts" className="hover:text-pastel-purple-600">User Accounts</a></li>
                <li><a href="#registry-services" className="hover:text-pastel-purple-600">Registry Services</a></li>
                <li><a href="#gift-contributions" className="hover:text-pastel-purple-600">Gift Contributions</a></li>
                <li><a href="#intellectual-property" className="hover:text-pastel-purple-600">Intellectual Property</a></li>
                <li><a href="#limitation-liability" className="hover:text-pastel-purple-600">Limitation of Liability</a></li>
                <li><a href="#changes" className="hover:text-pastel-purple-600">Changes to Terms</a></li>
                <li><a href="#contact-info" className="hover:text-pastel-purple-600">Contact Information</a></li>
              </ol>
            </div>

            <section id="acceptance" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">1. Acceptance of Terms</h2>
              <p className="mb-4 font-poppins">By accessing and using Giftyfy, you accept and agree to be bound by these Terms and Conditions and our Privacy Policy.</p>
            </section>

            <section id="user-accounts" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">2. User Accounts</h2>
              <ul className="list-disc list-inside space-y-2 ml-4 font-poppins text-gray-600">
                <li>You must be 18 years or older to create an account</li>
                <li>You are responsible for maintaining account security</li>
                <li>You must provide accurate and complete information</li>
                <li>You may not share or transfer your account</li>
              </ul>
            </section>

            <section id="registry-services" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">3. Registry Services</h2>
              <p className="mb-4 font-poppins">Our registry services are subject to the following terms:</p>
              <ul className="list-disc list-inside space-y-2 ml-4 font-poppins text-gray-600">
                <li>Registries must be created for legitimate purposes</li>
                <li>You may not create registries for illegal or prohibited items</li>
                <li>We reserve the right to remove inappropriate content</li>
                <li>Registry data may be deleted after extended inactivity</li>
              </ul>
            </section>

            <section id="gift-contributions" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">4. Gift Contributions</h2>
              <ul className="list-disc list-inside space-y-2 ml-4 font-poppins text-gray-600">
                <li>All contributions are subject to our Refund Policy</li>
                <li>We are not responsible for disputes between users</li>
                <li>Contributions must be made using valid payment methods</li>
                <li><strong>A platform fee of up to 3.69% may apply to transactions conducted through our service</strong></li>
              </ul>
            </section>

            <section id="intellectual-property" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">5. Intellectual Property</h2>
              <p className="mb-4 font-poppins">All content and materials available on Giftyfy are protected by intellectual property rights. You may not:</p>
              <ul className="list-disc list-inside space-y-2 ml-4 font-poppins text-gray-600">
                <li>Copy or reproduce our content</li>
                <li>Modify or create derivative works</li>
                <li>Use our trademarks without permission</li>
              </ul>
            </section>

            <section id="limitation-liability" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">6. Limitation of Liability</h2>
              <p className="mb-4 font-poppins">Giftyfy is provided "as is" without warranties of any kind. We are not liable for:</p>
              <ul className="list-disc list-inside space-y-2 ml-4 font-poppins text-gray-600">
                <li>Service interruptions or errors</li>
                <li>Loss of data or content</li>
                <li>Damages arising from use of our services</li>
              </ul>
            </section>

            <section id="changes" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">7. Changes to Terms</h2>
              <p className="mb-4 font-poppins">We reserve the right to modify these terms at any time. Continued use of Giftyfy constitutes acceptance of updated terms.</p>
            </section>

            <section id="contact-info" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">8. Contact Information</h2>
              <p className="mb-2 font-poppins">For questions about these terms, please contact us at:</p>
              <p className="mb-1 font-poppins"><strong>Email:</strong> legal@giftyfy.com</p>
              <p className="font-poppins"><strong>Phone:</strong> +94 779257975</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
